import { DownloadOutlined } from '@ant-design/icons';
import { Row, Table } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { downloadPDF, getDataDocumento } from '../../../../helpers/download';
import apiNetCore from '../../../../services/apiNetCore';
import { Button, Modal, Title } from './styles';

export default function ModalListDocuments({
  showModalListDocuments,
  handleCloseModalListDocuments,
  arrayDocumentsDownload = {},
}) {
  const closeModal = () => {
    handleCloseModalListDocuments();
  };

  const onClickAbrirDocumento = async link => {
    const response = await apiNetCore.get(link, { responseType: 'blob' });

    downloadPDF(response.data, Date.now());

    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    const pdfWindow = window.open();
    pdfWindow.location.href = fileURL;
  };

  const columns = [
    {
      title: 'Título',
      dataIndex: 'titulo',
      key: 'titulo',
      width: 250,
    },
    {
      title: 'Data de emissão',
      dataIndex: 'descricao',
      key: 'descricao',
      width: 200,
      render: text => getDataDocumento(text),
    },
    {
      title: 'Link',
      dataIndex: 'link',
      key: 'link',
      width: 50,
      render: (link, record) => (
        <>
          <Title>
            {record.titulo == 'Ordem de Carregamento' ? (
              <a
                href={`${process.env.REACT_APP_ATS_API_URL}${link}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <DownloadOutlined />
              </a>
            ) : (
              <a type="text" onClick={() => onClickAbrirDocumento(link)}>
                <DownloadOutlined aria-label="down" />
              </a>
            )}
          </Title>
        </>
      ),
    },
  ];

  return (
    <>
      <Modal
        title="Download de Documentos"
        width={550}
        onCancel={closeModal}
        visible={showModalListDocuments}
        destroyOnClose={true}
        footer={[
          <Button key="cancel" onClick={closeModal}>
            Fechar
          </Button>,
        ]}
      >
        <Row justify="center">
          {arrayDocumentsDownload && arrayDocumentsDownload.length >= 1 && (
            <>
              <Table
                dataSource={arrayDocumentsDownload}
                columns={columns}
                pagination={false}
                rowKey="documentosIndex"
              />
            </>
          )}
          {arrayDocumentsDownload && arrayDocumentsDownload.length < 1 && (
            <Title>Nao existem documentos para download</Title>
          )}
        </Row>
      </Modal>
    </>
  );
}

ModalListDocuments.propTypes = {
  arrayDocumentsDownload: PropTypes.arrayOf(
    PropTypes.shape({
      titulo: PropTypes.string,
      descricao: PropTypes.string,
      link: PropTypes.string,
    })
  ),
  showModalListDocuments: PropTypes.bool.isRequired,
  handleCloseModalListDocuments: PropTypes.func.isRequired,
};

ModalListDocuments.defaultProps = {
  arrayDocumentsDownload: [{}],
};
